export default __webpack_public_path__ + "static/media/about-bg.33eb4293.jpg";